import AxiosAPI from '../services/AxiosAPI';
/* global analytics */

export default {
  axiosAPI: new AxiosAPI(),

  isAdBlockerDetected() {
    // If we can find this id, that means our adframe.js file loaded successfully.
    // This indicates that adblocker is not present
    if (document.getElementById('aygHvTNdwLZt')) {
      return false;
    }
    return true;
  },

  track(event, attributes) {
    this.call('track', event, attributes);
  },

  page(pageName, pageTitle = document.title, pageUrl = window.location.href) {
    this.call('page', pageName, {
      name: pageName,
      title: pageTitle,
      url: pageUrl,
      search: window.location.search,
      referrer: document.referrer,
      path: window.location.pathname,
    });
  },

  identify(userId, attributes) {
    const { user } = window.$store.getters;
    attributes = attributes || {};
    if (user) {
      attributes.email = user.email;
    }
    this.call('identify', userId, attributes, {});
  },

  call(method, event, attributes, additionalData) {
    // let context = null;
    // const gaCookie = this.getGACookie();
    // if (gaCookie) {
    //   context = {
    //     context: {
    //       'Google Analytics': {
    //         clientId: gaCookie,
    //       },
    //     },
    //   };
    // }
    const { user, acceptedCookiePolicy, country } = window.$store.getters;
    const episodeStreamEvents = ['Episode Playback Speed', 'Episode Rewind', 'Episode Fast Forward', 'Episode Scrub', 'Episode Play', 'Episode Stop', 'Episode Heartbeat'];
    if (!acceptedCookiePolicy && country === 'GB' && episodeStreamEvents.indexOf(event) < 0) {
      return;
    }

    if (!this.isAdBlockerDetected() && episodeStreamEvents.indexOf(event) < 0) {
      analytics[method](event, attributes, additionalData);
    } else if (user && user.uuid) {
      const params = this.getParamsByMethod(method, event, attributes);
      this.axiosAPI.post(`v1/segment/${method}`, params);
    }
  },

  getGACookie() {
    let GACookie = null;
    let cookies = document.cookie;
    const cookiesMap = {};
    cookies = cookies.split('; ');
    if (cookies.length) {
      cookies.forEach((c) => {
        c = c.split('=');
        const [key, value] = c;
        cookiesMap[key] = value;
      });
    }
    const { _ga } = cookiesMap;
    if (_ga && _ga.length) {
      GACookie = _ga.substr(6);
    }
    return GACookie;
  },

  getParamsByMethod(method, event, attributes) {
    let params = {};
    if (attributes) {
      switch (method) {
        case 'page':
          params = {
            page_name: attributes.name,
            page_title: attributes.title,
            page_url: attributes.url,
          };
          break;
        case 'identify':
          params = attributes;
          break;
        case 'track':
          params = {
            event_type: event,
            event_params: attributes,
          };
          break;
        default:
          break;
      }
    }
    return params;
  },

  deleteAllCookies() {
    let cookies = document.cookie;
    cookies = cookies.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const key = cookies[i].split('=');
      let host = document.domain;
      host = host.split('.');
      const domain = `.${host[host.length - 2]}.${host[host.length - 1]}`;
      const path = '/';
      document.cookie = `${key[0]}=; expires= Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=${path}`;
    }
  },
};



// WEBPACK FOOTER //
// ./app/src/shared/analytics.js